import { Reveal } from "./Reveal";
import { scrollToId } from "@/lib/svenData";

/*
 * STORY / MANIFESTO — PLACEHOLDER COPY, client to replace.
 * The lead paragraph below is the approved placeholder from the brief.
 * Chapter blurbs are editorial filler in the same voice — also placeholder.
 
const CHAPTERS = [
  { num: "01", title: "One Pattern, One Man", text: "No standard blocks. Every garment begins with a pattern drafted from your measurements alone — and retired only for you." },
  { num: "02", title: "Made in Mumbai", text: "Cut, canvassed and finished by hand across our two ateliers on Swami Vivekanand Road — Santacruz and Bandra." },
  { num: "03", title: "Fitted Until Right", text: "A suit is finished when it disappears on you. We fit, refine and re-fit until the silhouette is unmistakably yours." },
];
*/
export const Story = () => (
  <section id="story" data-testid="manifesto-story-section" className="bg-[#faf8f5] py-20 lg:py-30 overflow-hidden">
    <div className="max-w-7xl mx-auto px-10 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-14 lg:gap-10">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="overline-label mb-6">THE HOUSE OF SVEN</p>
          </Reveal>
          <Reveal delay={0.1}>
            {/* PLACEHOLDER COPY — client to replace */}
            <h2 className="font-display text-3xl sm:text-3xl lg:text-4xl font-medium leading-snug text-[#141414] max-w-2xl">
            Tailoring is a{" "}
              <em className="font-accent text-[#99732b] text-3xl sm:text-3xl lg:text-4xl text-weight:600">Conversation</em>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-md sm:text-base font-light leading-relaxed text-[#57534e] max-w-xl">
            SVEN SUITS was founded on a simple belief: exceptional clothing begins with exceptional fit. 
            Every garment is considered around the person wearing it — proportions, movement, fabric, lifestyle and occasion.
            <br />
            From the first consultation to the final fitting, the process remains personal. 
            The result is clothing that does not merely fit you. It belongs to you.
            </p>
          </Reveal>
          
          {/* Centered button container */}
          <div className="flex justify-center p-6">
            <Reveal delay={0.2}>
              <button
                data-testid="open-booking-section-btn"
                onClick={() => scrollToId("book")}
                className="mt-8 px-10 py-3.5 border border-[#99732b] bg-[#c5a059] text-[#ffffff] font-mono-ov text-xs tracking-[0.15em] uppercase hover:bg-[#dfcca4] hover:text-[#0b0b0c] hover:scale-[1.02] transition-all duration-300"
              >
                Begin Your Journey
              </button>
            </Reveal>
          </div>
          {/*
          <div className="mt-16 space-y-0 max-w-xl">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.num} delay={0.1 * i}>
                <div data-testid={`manifesto-chapter-${c.num}`} className="group flex gap-6 py-7 border-t border-[#e7e2da] last:border-b hover:bg-white/60 transition-colors px-3 -mx-3">
                  <span className="font-font text-xl text-[#c5a059] leading-none pt-1">{c.num}</span>
                  <div>
                    <h3 className="font-display text-xl text-[#141414]">{c.title}</h3>
                    <p className="mt-2 text-sm font-light leading-relaxed text-[#57534e]">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          */}
        </div>

        <div className="lg:col-span-5 relative">
          <Reveal delay={0.15} y={60}>
            <div className="relative">
            <div className="absolute -top-4 -left-4 w-full h-full border border-[#c5a059]/40 rounded-t-[0px]" />
              <div className="absolute -top-6 -left-6 w-full h-full border border-[#c5a059]/40 rounded-t-[0px]" />
              <div className="absolute -top-8 -left-8 w-full h-full border border-[#c5a059]/40 rounded-t-[0px]" />
              <div className="overflow-hidden rounded-t-[0px] bg-[#f2ede6]">
                <img
                  src="/images/products/story_image.png"
                  alt="Taupe double-breasted bespoke suit by Sven"
                  className="w-full h-[420px] lg:h-[520px] object-cover object-top hover:scale-105 transition-transform duration-[1.4s] ease-out"
                />
              </div>
              <p className="mt-4 font-mono-ov text-[10px] tracking-[0.22em] uppercase text-[#57534e]/70 text-right">Hand-finished · Swami Vivekanand Rd, Mumbai</p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);